<template>
  <div
    ref="pdfViewer"
    class="pdf-viewer"
    :class="{ 'p-relative--20px': urlFrom === 'detail' }"
  >
    <div v-if="loading" class="loading">Loading PDF...</div>
  </div>
</template>

<script>
import pdfjsLib from "pdfjs-dist";
import "pdfjs-dist/build/pdf.worker.entry";

export default {
  name: "PdfViewer",
  props: {
    pdfUrl: {
      type: String,
      default: "",
    },
    urlFrom: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      pdf: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.pdfUrl) {
        this.loadPdf(this.pdfUrl);
      }
    });
  },
  watch: {
    pdfUrl(newUrl, oldUrl) {
      if (newUrl && newUrl !== oldUrl) {
        this.$nextTick(() => {
          this.loadPdf(newUrl);
        });
      }
    },
  },
  methods: {
    async loadPdf(url) {
      if (!url) return;

      this.loading = true;

      try {
        this.clearPdf();

        const loadingTask = pdfjsLib.getDocument(url);

        this.pdf = await loadingTask.promise;

        for (
          let pageNumber = 1;
          pageNumber <= this.pdf.numPages;
          pageNumber++
        ) {
          const page = await this.pdf.getPage(pageNumber);

          const containerWidth = this.$refs.pdfViewer.clientWidth;

          const originalViewport = page.getViewport(1);

          const scale = containerWidth / originalViewport.width;

          const viewport = page.getViewport(scale);

          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");

          canvas.width = viewport.width;
          canvas.height = viewport.height;

          canvas.style.width = "100%";
          canvas.style.height = "auto";

          this.$refs.pdfViewer.appendChild(canvas);

          await page.render({
            canvasContext: context,
            viewport: viewport,
          }).promise;
        }
      } catch (error) {
        console.error("PDF error:", error);
      } finally {
        this.loading = false;
      }
    },
    clearPdf() {
      if (!this.$refs.pdfViewer) return;

      const canvases = this.$refs.pdfViewer.querySelectorAll("canvas");

      canvases.forEach((canvas) => {
        canvas.remove();
      });

      this.pdf = null;
    },
  },
};
</script>
<style scoped>
.p-relative--20px {
  position: relative;
  top: -20px;
}

.pdf-viewer {
  width: 150px;
  height: 75px;
  overflow-y: auto;
  overflow-x: hidden;
  background: #eee;
  padding: 5px;
}

.pdf-viewer canvas {
  display: block;
  width: 100%;
  height: auto;
  margin: 0 auto 0;
  background: #fff;
}

.loading {
  text-align: center;
  padding: 20px;
  color: #666;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/PdfViewer.vue